import { render, staticRenderFns } from "./ReportsInventorySectionView.vue?vue&type=template&id=b97f052e&scoped=true"
import script from "./ReportsInventorySectionView.vue?vue&type=script&lang=js"
export * from "./ReportsInventorySectionView.vue?vue&type=script&lang=js"
import style0 from "./ReportsInventorySectionView.vue?vue&type=style&index=0&id=b97f052e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97f052e",
  null
  
)

export default component.exports